export default __webpack_public_path__ + "static/media/done.e036971b.png";